import { FC } from "react";

interface IconUserProps {
  className?: string;
}

const IconUser: FC<IconUserProps> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="6" r="4" fill="#4F5E71" stroke="#4F5E71" strokeWidth="1.5" />
      <ellipse cx="12" cy="17" rx="7" ry="4" fill="#4F5E71" stroke="#4F5E71" strokeWidth="1.5" />
    </svg>
  );
};

export default IconUser;
